import { keyBy } from 'lodash'
import DiscountsAPIs from '@/API/promotions/discounts-api'
import FormsService from '@/services/forms-service'

// @ts-ignore
// @ts-ignore
export default {
  namespaced: true,
  state: {
    discountsCount: null,
    discountsData: [],
    discounts: [],
    discountsBranchId: null,
  },

  getters: {
    discounts: (state: any) => state.discounts,
    structuredDiscounts: (state: any) => {
      const sellingTypes = ['dine_in', 'delivery', 'car_pickup', 'car_pickup_with_details']
      const result = {}

      // Initialize all selling types
      sellingTypes.forEach(type => {
        // @ts-ignore
        result[type] = {
          items: [],
          categories: [],
          all_menu: false,
        }
      })
      // Build structured discounts from discountData
      if (Array.isArray(state.discounts)) {
        state.discounts.forEach((discount: any) => {
          // eslint-disable-next-line no-restricted-syntax
          for (const type in discount.selling_types) {
            // @ts-ignore
            // eslint-disable-next-line no-continue
            if (!result[type]) continue

            // all_menu discount
            if (discount.all_menu) {
              // @ts-ignore
              result[type].all_menu = {
                discount_id: discount.id,
                value: discount.discount_value,
                type: discount.discount_type === '%' ? 'percent' : 'fixed',
              }
            }

            // category discounts
            if (Array.isArray(discount.categories) && discount.categories.length > 0) {
              const categories = discount.categories.map((cat: any) => ({
                id: cat.id,
                discount_id: discount.id,
                value: discount.discount_value,
                type: discount.discount_type === '%' ? 'percent' : 'fixed',
              }))
              // @ts-ignore
              result[type].categories.push(...categories)
            }

            // item discounts
            if (Array.isArray(discount.items) && discount.items.length > 0) {
              const items = discount.items.map((item: any) => ({
                id: item.id,
                discount_id: discount.id,
                value: discount.discount_value,
                type: discount.discount_type === '%' ? 'percent' : 'fixed',
              }))
              // @ts-ignore
              result[type].items.push(...items)
            }
          }
        })
      }

      return result
    },
    // ✅ Now this depends on structuredDiscounts
    currentSellingTypeDiscounts: (state: any, getters: any) => (orderType = 'dine_in') => getters.structuredDiscounts?.[orderType] ?? {},
    itemsDiscounts: (state: any, getters: any) => (orderType = 'dine_in') => {
      // call the currentSellingTypeDiscounts getter with orderType
      const currentDiscounts = getters.currentSellingTypeDiscounts(orderType)
      return keyBy(currentDiscounts?.items ?? [], 'id')
    },
    categoriesDiscounts: (state: any, getters: any) => (orderType = 'dine_in') => {
      const currentDiscounts = getters.currentSellingTypeDiscounts(orderType)
      return keyBy(currentDiscounts?.categories ?? [], 'id')
    },
    getItemDiscount: (state: any, getters: any) => (item: any, appliedDiscounts: Array<any>, orderType: string) => {
      if (!appliedDiscounts) {
        return state.itemsDiscounts[item?.id]
          || state.categoriesDiscounts[item?.category_id]
          || state.allMenuDiscount
          || false
      }
      // Check item discount
      const itemDiscount = getters.itemsDiscounts(orderType)?.[item?.id]
      if (itemDiscount && appliedDiscounts.includes(itemDiscount.discount_id)) {
        return itemDiscount
      }

      // Check category discount
      const categoryDiscount = getters.categoriesDiscounts(orderType)?.[item?.category_id]
      if (categoryDiscount && appliedDiscounts.includes(categoryDiscount.discount_id)) {
        return categoryDiscount
      }

      // Check all-menu discount
      if (state.allMenuDiscount?.discount_id && appliedDiscounts.includes(state.allMenuDiscount.discount_id)) {
        return state.allMenuDiscount
      }

      // No discount found
      return false
    },
    // Assuming you already have getItemDiscount defined
    calcItemPrice: (state: any, getters: any) => (item: any, customNetPrice: any, appliedDiscounts: Array<any> = [], orderType: string) => {
      // Get the discount for this item
      const itemDiscount = getters.getItemDiscount(item, appliedDiscounts, orderType)
      // Determine the net price
      const netPrice = parseFloat(customNetPrice ?? item.netPrice ?? item.price ?? 0)
      // Validation: if no discount or no value, return netPrice
      if (!itemDiscount || !itemDiscount.value || !netPrice) {
        return netPrice
      }
      // Calculate final price based on discount type
      switch (itemDiscount.type) {
        case 'percent':
          return Math.max(netPrice - (netPrice * itemDiscount.value) / 100, 0)
        case 'fixed':
          return Math.max(netPrice - itemDiscount.value, 0)
        default:
          return netPrice
      }
    },
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      const discounts = Array.isArray(payload) ? payload : payload.discounts
      state.discounts = discounts
      if (!Array.isArray(payload) && payload.branchId != null) {
        state.discountsBranchId = payload.branchId
      }
    },
  },
  actions: {
    async FETCH_DISCOUNTS(context: any, { branchId }: any = {}) {
      if (
        branchId != null
        && context.state.discountsBranchId === branchId
        && Array.isArray(context.state.discounts)
      ) {
        return
      }
      try {
        // prepare query string
        const queryString = FormsService.prepareQueryString({ per_page: 1000 }, true)
        // call API
        const data = await DiscountsAPIs.getDiscounts(branchId, queryString)
        const now = new Date()
        // filter discounts based on validity
        const validDiscounts = data.discounts.filter((d: any) => {
          const start = new Date(d.valid_from)
          const end = new Date(d.valid_until)
          // check date validity
          const isValidDate = now >= start && now <= end
          // check selling type validity (value === 1 means active)
          // const isValidSellingType = d?.selling_types?.[sellingType] === 1
          // return isValidDate && isValidSellingType
          return isValidDate
        })
        // commit only valid discounts to state
        context.commit('SET_DATA', {
          discounts: validDiscounts,
          branchId,
        })
      } catch (err) {
        console.error('Error fetching discounts:', err)
      }
    },
  },
}
